import "./index.css";
import EthChart from "./EthChart";

export function App() {
  return (
    <div>
      <EthChart />
    </div>
  );
}

export default App;
